module.exports = __webpack_public_path__ + "static/media/mobileviewz.254ad73c.png";